module.exports = __webpack_public_path__ + "img/CEV2412.4bf0aa76.png";